// src/components/About.js
import React, { useEffect } from 'react';
import adimg1 from '../images/adimg1.jpg';
import postProperty1 from '../images/post-property1.png';
import top3 from '../images/top3.png';

import topbatch from '../images/topbatch.png';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAds } from '../redux/adSlice';
import { fetchTopProjects } from '../redux/homeSlice';
import { fetchPopularLocalities } from '../redux/popularLocalitySlice';
import AdvertisementType2 from './AdvertisementType2';
import AdvertisementType1 from './AdvertisementType1';
import AdvertisementTopProjects from './AdvertisementTopProjects';
import AdvertisementLocality from './AdvertisementLocality';
import AdvertisementTopResale from './AdvertisementTopResale';
const Advertisement = ({ param = { id: 1, name: 'Jaipur' }, prefix = 'srcid', service }) => {
  const dispatch = useDispatch();
  const { ads, status: adsStatus, error: adsError } = useSelector((state) => state.ads);
  const { topProjects, status: homeStatus, error: homeError } = useSelector((state) => state.home);
  const { popularLocalities, status: localityStatus, error: localityError } = useSelector((state) => state.popularLocalities);


  // alert(JSON.stringify(topProjects));
  useEffect(() => {
    if (param?.id) {
      dispatch(fetchAds(param?.id));
      dispatch(fetchTopProjects());
      dispatch(fetchPopularLocalities());
    }
  }, []);







  return (

    <div className='ad-sidebar'>

      <div className='ad-side-cover'>


        <AdvertisementType1 />

        <AdvertisementType2 />


        <AdvertisementTopProjects topProjects={topProjects} param={param} prefix={prefix} />

        <AdvertisementLocality popularLocalities={popularLocalities} />


        <AdvertisementTopResale topProjects={topProjects} param={param} />


        <div className='post_property desk mt-3'>
          <Link to="/postProperty">
            <img src={postProperty1} className="card-img-top mt-0" alt="..." />
          </Link>
        </div>
      </div>

    </div>



  );
};

export default Advertisement;
